<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <div class="col-sm-12">
        <ComponentForm v-if="component" :component="component" />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ComponentForm from '@/components/settings/stock-registers/component/ComponentForm.vue'

export default {
  name: 'ComponentEdit',
  components: {
    PageTitle,
    PageRowWrapper,
    ComponentForm
  },
  computed: {
    ...mapState({
      component: state => state.component.componentById
    })
  },
  methods: {
    ...mapActions('component', ['fetchById'])
  },
  mounted () {
    this.fetchById(this.$route.params.id)
  }
}

</script>